import useLocalStorage from './useLocalStorage'

import type { PlaceIdAddress } from '@/types/store'

export default function usePlugin() {
  const { isSupportConnection } = useLocalStorage()

  const installMetaPixel = () => {
    ;(function (f: any, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        // eslint-disable-next-line
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore:next-line
    fbq('init', import.meta.env.VITE_META_PIXEL_ID)

    if (!isSupportConnection.value) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore:next-line
      fbq('track', 'PageView')
    }
  }

  const installSentryProxy = () => {
    // Sentry Proxy to prevent adblockers
    /* eslint-disable */
    if ('Proxy' in window) {
      var n = {
        get: function (o, e) {
          return new Proxy(function (n) {
            return 'flush' === e || 'close' === e
              ? Promise.resolve()
              : 'function' == typeof n
                ? n(window.Sentry)
                : window.Sentry
          }, n)
        }
      }
      window.Sentry = new Proxy({}, n)
      /* eslint-enable */
    }
  }

  const installGoogleMapsAPI = async () => {
    return new Promise<void>((resolve, reject) => {
      const scriptId = 'google-maps-script-import'

      if (document.getElementById(scriptId)) {
        resolve()
        return
      }
      const googleScript = document.createElement('script')
      googleScript.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GOOGLE_PLACES_API_KEY}&libraries=places`
      )
      googleScript.setAttribute('id', scriptId)
      googleScript.addEventListener('load', () => {
        resolve()
      })
      googleScript.addEventListener('error', (error) => {
        reject(new Error(`Failed to load Google Maps API: ${error.message}`))
      })
      document.head.appendChild(googleScript)
    })
  }

  const getAddressFromPlaceId = (googlePlaceId?: string): Promise<PlaceIdAddress> => {
    if (!googlePlaceId) {
      return
    }
    return new Promise((resolve, reject) => {
      const address = <PlaceIdAddress>{
        streetType: null,
        streetName: null,
        streetNumber: null,
        zipCode: null,
        city: null,
        country: null
      }
      const map = new google.maps.Map(document.createElement('div'))
      const request = {
        placeId: googlePlaceId,
        fields: ['address_components']
      }
      const service = new google.maps.places.PlacesService(map)

      service.getDetails(request, (place, status) => {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          const placeAddress = place.address_components
          const addressRoute = placeAddress.filter((address) => address.types[0] === 'route')[0]
          if (addressRoute) {
            const streetName = addressRoute?.long_name.split(' ')
            streetName.shift()
            address.streetType = placeAddress
              .filter((address) => address.types[0] === 'route')[0]
              ?.long_name.split(' ')[0]
            address.streetName = streetName.join(' ')

            const streetNumber = placeAddress.filter((address) => address.types[0] === 'street_number')
            address.streetNumber = streetNumber.length ? streetNumber[0]?.long_name : null
          }
          address.zipCode = placeAddress.filter((address) => address.types[0] === 'postal_code')[0]?.long_name
          address.city = placeAddress.filter((address) => address.types[0] === 'locality')[0]?.long_name
          address.country = placeAddress.filter((address) => address.types[0] === 'country')[0]?.long_name

          resolve({
            streetNumber: address.streetNumber,
            streetType: address.streetType,
            streetName: address.streetName,
            zipCode: address.zipCode,
            city: address.city,
            country: address.country
          })
        } else {
          reject('Failed to get details for the placeId')
        }
      })
    })
  }

  const installSegment = () => {
    /* eslint-disable */
    // @ts-ignore:next-line
    !(function () {
      // @ts-ignore:next-line
      var analytics = (window.analytics = window.analytics || [])
      // @ts-ignore:next-line
      if (!analytics.initialize) {
        // @ts-ignore:next-line
        if (analytics.invoked) {
          window.console && console.error && console.error('Segment snippet included twice.')
        } else {
          // @ts-ignore:next-line
          analytics.invoked = !0
          // @ts-ignore:next-line
          analytics.methods = [
            'trackSubmit',
            'trackClick',
            'trackLink',
            'trackForm',
            'pageview',
            'identify',
            'reset',
            'group',
            'track',
            'ready',
            'alias',
            'debug',
            'page',
            'once',
            'off',
            'on',
            'addSourceMiddleware',
            'addIntegrationMiddleware',
            'setAnonymousId',
            'addDestinationMiddleware'
          ]
          // @ts-ignore:next-line
          analytics.factory = function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments)
              t.unshift(e)
              // @ts-ignore:next-line
              analytics.push(t)
              return analytics
            }
          }
          // @ts-ignore:next-line
          for (var e = 0; e < analytics.methods.length; e++) {
            // @ts-ignore:next-line
            var key = analytics.methods[e]
            // @ts-ignore:next-line
            analytics[key] = analytics.factory(key)
          }
          // @ts-ignore:next-line
          analytics.load = function (key, e) {
            var t = document.createElement('script')
            t.type = 'text/javascript'
            t.async = !0
            t.src = 'https://analytics.heypongo.com/' + key + '/analytics.min.js'
            var n = document.getElementsByTagName('script')[0]
            n.parentNode.insertBefore(t, n)
            // @ts-ignore:next-line
            analytics._loadOptions = e
          }
          // @ts-ignore:next-line
          ;((analytics._writeKey = import.meta.env.VITE_SEGMENT_TOKEN), (analytics.SNIPPET_VERSION = '4.15.3'))
          // @ts-ignore:next-line
          analytics.load(import.meta.env.VITE_SEGMENT_TOKEN, {
            integrations: {
              'Segment.io': {
                apiHost: import.meta.env.MODE === 'production' ? 'tracking.heypongo.com/v1' : 'api.segment.io/v1'
              }
            }
          })
        }
      }
    })()
    /* eslint-enable */
  }

  const installPlugins = () => {
    installSentryProxy()
    installMetaPixel()
    installSegment()
  }

  return {
    installMetaPixel,
    installSentryProxy,
    installPlugins,
    installGoogleMapsAPI,
    getAddressFromPlaceId
  }
}
